import { getLog } from "../helpers/helpers.js"
import { waitIfConcurrentAndReturnRes } from "./concurrent_wait_and_res.js"
import OraclesUtils from "./OraclesUtils.js"
import { runcraft_cache } from "./runcraft_cache.js"


// TODO this works for tokkenr but will not if we release for web usage
function isElectron() {
    var userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.indexOf(' electron/') > -1) return true
    return false
}
const is_nodejs = (typeof window === 'undefined')
export const isDevMode = !is_nodejs && !isElectron()


class RunCraft {

    // design pattern used: https://stackoverflow.com/a/31471915

    // FOR A REASON THAT I TOTALLY DONT GET: IF I REMOVE STATIC ON CONSTRUCTOR IT BREAKS RUNCRAFT IN THE APP
    // (even if the linter says to not add static to the constructor!)
    static constructor() {
        // make sure no one but the init function can call the constructor
        if (!this.from_init)
            throw new Error("The constructor is private, please use the init_async function:"
                + "this.from_init=" + this.from_init)
        this.from_init = false
    }


    /**
     * The actual constructor is this init() function. We want it async
     * to avoid forcing users to call .init() after creating the instance.
     * @param {a_Run_instance} run 
     * @param {array} trusted_txids accelerate loading by providing already-trusted txids
     *                  BUT ONLY IF ALL RECURSIVE BEHIND THEM IS ALREADY IN THE LIST TOO
     *                  this is already done in Oraclesutils.trustRecursive()
     *                  so you can save this file in the save() of a run.cache = customCache
     * @returns a_Runcraft_instance
     */
    static async init_async(run, trusted_txids = [], generateCache = false) {
        this.classname = "RunCraft: "
        const function_id = this.classname + "init_async(): "
        const log = getLog(function_id)

        log("init")

        run.activate()
        this.OraclesUtils = new OraclesUtils(run, trusted_txids)  // init OraclesUtils with run

        log("step 2")

        this.from_init = true
        const runcraft = new RunCraft()

        // it's best to NOT do this.run=run because then if we log Runcraft it would log privkeys!

        log("step 3")

        for (let i = 0; i < trusted_txids.length; i++) {
            run.trust(trusted_txids[i])
        }

        // TODO this is a temporary fix, should rather be fixed in trustRecursive() ?
        // this happens when you don't redeploy OracleRequest_USDpriced but you dereploy others
        // but loading all inputs recursively is too slow, so we use this fix
        const to_trust_txids = [
            // "4622b0f2a8740e1d58648e199daed8f2bfbff0ae07dee3c91e9b281bbd9844fe",
            // "f632fd86d3f0bd29e4aac4652e5fd046c19508bea8c8ed352fac6ea87e9e36c6",
        ]
        for (let i = 0; i < to_trust_txids.length; i++) {
            run.trust(to_trust_txids[i])
        }

        log("step 4")

        let mess = ""

        var contracts_to_load = this._get_contracts_to_load()
        if (generateCache) {
            // Add the trustlist of all previously used contracts, to read more search #FDF4E5G43
            // TODO might be able to deprecate get_legacy_trustlist() once tests are over ? unsure so tests are needed 
            contracts_to_load = { ...contracts_to_load, ...get_legacy_trustlist() }
        }
        else {  // normal RunCraft loading
            mess = "prepopulating run cache with RunCraft cache"
            log(mess)
            // prepopulate cache in run
            let keys = Object.keys(runcraft_cache)
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i]
                let val = runcraft_cache[key]
                run.cache.set(key, val)
            }

            // we must also trust (not load nor sync!!) the legacy stuff
            let legacy_trustlist = Object.values(get_legacy_trustlist())
            let already_trusted = [] // we have a lot of dups so this should help
            for (let i = 0; i < legacy_trustlist.length; i++) {
                let totrust = legacy_trustlist[i].split('_')[0]
                if (!already_trusted.includes(totrust)) {
                    already_trusted.push(totrust)
                    log("trusting legacy:", totrust)
                    run.trust(totrust)
                }
            }
            log("finished " + mess)
        }

        mess = "loading all RunCraft contracts from cache..."
        log(mess)

        const allkeys = Object.keys(contracts_to_load)
        log("step 5: allkeys res=", allkeys)

        // because calling with with_sync is too slow on startup, we call with it false
        // and then we will asynchronously call again with it at true
        let with_sync = false
        if (generateCache) with_sync = true  // only exception
        let all_res = await this._load_all_contracts(
            run, contracts_to_load, with_sync, function_id
        )

        // log("step 6: load_all_contracts res=", all_res)  // log too big

        // clean-up user-exposed runcraft objects from legacy stuff
        for (let i = 0; i < all_res.length; i++) {
            const curr_res = all_res[i]
            const curr_key = allkeys[i]
            // don't expose legacy_ stuff to runcraft users (same for trust_ stuff)
            if (!curr_key.includes("legacy_") && !curr_key.includes("trust_")) {
                runcraft[curr_key] = curr_res
                this[curr_key] = curr_res  // add to global RunCraft singleton
                log("added to this: key=", curr_key, "!!curr_res=", !!curr_res)
            }
        }
        log("step 7: finished", mess, "allkeys=", allkeys)

        if (isDevMode) log("runcraft=", runcraft)
        if (generateCache) {
            // use this for generating a partial cache file to manually save & reuse
            mess = "RunCraft cache is ready."
            console.log(mess)
            alert(mess)
            process.exit(1)
        }

        log("finished")
        return runcraft
    }


    /**
     * @param {Run instance} run - run instance
     */
    async syncAll(run) {  // allow calling from an instance & redirect to the static version
        return await this.constructor.syncAll(run)
    }


    /**
     * because this is slow so we do it once the wallet has loaded to the user, asynchronously
     * 
     * @param {Run instance} run - run instance
     */
    static async syncAll(...args) {  // debouncer
        return await waitIfConcurrentAndReturnRes.call(this, this._syncAll, ...args)
    }
    static async _syncAll(run) {
        const function_id = "RunCraft: syncAll(): "
        const log = getLog(function_id)

        log("init")

        // retrieve the keys of the contracts to load
        const old_contracts_to_load = this._get_contracts_to_load()
        const contracts_keys_to_load = Object.keys(old_contracts_to_load)

        log(contracts_keys_to_load.length, "contracts_keys_to_load=", contracts_keys_to_load)

        // inject into contracts_to_load from 'this' if possible
        const contracts_to_load = {}
        for (let i = 0; i < contracts_keys_to_load.length; i++) {
            const key = contracts_keys_to_load[i]
            if (this[key]) {
                const contract_origin = this[key].origin
                log(i, "key=", key, "\n contract_origin=", contract_origin)
                if (!contract_origin) log("key=", key, "\n this[key]=", this[key])
                contracts_to_load[key] = contract_origin
            }
            else {
                console.error(function_id + "contract not found in RunCraft for key=" + key)
                contracts_to_load[key] = old_contracts_to_load[key]
            }
        }

        const with_sync = true
        await this._load_all_contracts(run, contracts_to_load, with_sync, function_id)
    }



    /** 
     * @param {*} run - run instance
     * @param {dict} contracts_to_load - dict of name->origin
     * @param {boolean} with_sync - 
     * @param {string} function_id - for logging
    */
    static async _load_all_contracts(run, contracts_to_load, with_sync, function_id) {
        function_id += "_load_all_contracts(): (with_sync=" + String(with_sync) + ")"
        const log = getLog(function_id)

        const allkeys = Object.keys(contracts_to_load)
        log("Object.keys(contracts_to_load)=", allkeys)

        let start_time = Date.now()

        // parallel: 80 to 150s vs sequential: same!
        // // trust & load all contracts sequentially
        // let all_res=[]
        // for(let i = 0; i < allkeys.length; i++){
        //     const curr_key = allkeys[i]
        //     const curr_origin = contracts_to_load[curr_key]
        //     const curr_contract = await this.OraclesUtils.load_trustRecursive(run, curr_origin, with_sync)
        //     all_res.push(curr_contract)
        //     if(isDevMode) log(i,"/",allkeys.lengh)
        // }

        // trust & load all contracts in parallel
        let all_promises = []
        for (const curr_key of allkeys) {
            const curr_origin = contracts_to_load[curr_key]
            all_promises.push(this.OraclesUtils.load_trustRecursive(run, curr_origin, with_sync))
        }
        if (isDevMode) log("all_promises=", all_promises)

        // this what's taking the most time on wallet load for now
        // we could do it right from app opening instead ?
        // or we could do it after everything else has loaded (to update oracle prices etc)
        // ex: do a first load_trustRecursive(..., false) and then do one with (..., true)
        log("starting load_trustRecursive() of all contracts")
        var all_res = await Promise.all(all_promises)

        log(allkeys.length, "allkeys=", allkeys)

        for (let i = 0; i < allkeys.length; i++) {
            const curr_key = allkeys[i]
            const curr_res = all_res[i]
            log("adding key", curr_key, "to RunCraft object")
            this[curr_key] = curr_res  // add to global RunCraft singleton
        }

        if (isDevMode) log("all_res=", all_res)
        let time_spent = Date.now() - start_time
        log("time_spent=", time_spent, "ms to load all ", all_res.length, "contracts with with_sync=", with_sync)

        return all_res
    }




    static _get_contracts_to_load() {
        return {
            // tip: comment the ones you want to redeploy (you might also need to delete the cache file first)

            // OracleRequest_USDpriced is the base class, others are directly callable oracles 

            // BEWARE DO NOT REDEPLOY BEFORE TURNING OFF CACHE OR YOU WILL GET METADATA MISMATCH (use_file_cache)
            // BEWARE COMMENTING OR DELETING CONTRACTS HERE CAN MAKE SOME COINS DISAPPEAR, to read more search: #FDF4E5G43

            OracleRequest_USDpriced: "8bd2d9eef29a2ed8a7f33b22443ef2808060b189eb7f7a11aedfa2d8c2ecbc7a_o1",

            Oracle_BSVUSD: "43631da7167f06a16e0cfe1446beb4e842a62922c5e24e60989ac12565ce1142_o1",
            Oracle_BSVEUR: "f5f496086c47fea4cee80ce9c2a35ac4f4d2fb694c2d78c72fb1cb027658f579_o1",
            Oracle_Timestamp: "0b026a260e9abb7b4a2d73d687e2c9a36549cc752b7800a9c307bddf2be1a20a_o1",
            Oracle_RandomValue: "b4ac410af2e233f8bc532c611617ca53a2fb33a4b75d47224a713316e8254452_o1",

            // other stuff
            RunMath: "25bd0d8253e31d2ac78a9ad4c3b2eb87af079a7bb7c331938f6e2ea86f9ea32c_o3",
            Use_OracleRequest_USDpriced: "25bd0d8253e31d2ac78a9ad4c3b2eb87af079a7bb7c331938f6e2ea86f9ea32c_o1",
            BSV_Payment: "25bd0d8253e31d2ac78a9ad4c3b2eb87af079a7bb7c331938f6e2ea86f9ea32c_o7",

            TokenSellRequest_Admin: "25bd0d8253e31d2ac78a9ad4c3b2eb87af079a7bb7c331938f6e2ea86f9ea32c_o6",
            TokenSellRequest_User: "25bd0d8253e31d2ac78a9ad4c3b2eb87af079a7bb7c331938f6e2ea86f9ea32c_o4",

            RunConvert: "f626a0bcaf83384b007da4a6385936df5573fad56098f2acb2b5c3bf17b5aac0_o7",
            BSV_Refund: "f626a0bcaf83384b007da4a6385936df5573fad56098f2acb2b5c3bf17b5aac0_o6",

            TokenBuyRequest_User: "f626a0bcaf83384b007da4a6385936df5573fad56098f2acb2b5c3bf17b5aac0_o4",
            TokenBuyRequest_Admin: "f626a0bcaf83384b007da4a6385936df5573fad56098f2acb2b5c3bf17b5aac0_o9",
            AvailableTokensContract: "f626a0bcaf83384b007da4a6385936df5573fad56098f2acb2b5c3bf17b5aac0_o10",
            Oracle_TokenBuyRequest_BasePrice: "f626a0bcaf83384b007da4a6385936df5573fad56098f2acb2b5c3bf17b5aac0_o5",
            NotEnoughTokensLeftAtBasePrice: "f626a0bcaf83384b007da4a6385936df5573fad56098f2acb2b5c3bf17b5aac0_o11",


            // BEWARE COMMENTING OR DELETING CONTRACTS HERE CAN MAKE SOME COINS DISAPPEAR, to read more search: #FDF4E5G43
            // TODO retest if really an issue because I am unsure if I fixed it or not

            // THIS IS A VERY BAD FIX TO MAKE IT WORK BUT RUN SHOULD FIX ITS DEPENDANCIES TO NOT HAVE TO DO THIS
            // otherwise I won't be able to deploy such an oracle for other clients if I need to trust all of their contracts first
            //
            // THIS SHOULD NOT BE SHARED even if there is no security risk to share it
            // trust token contract for clients, required since we insert such tokens to TokenSellRequest_User
            // but why since they are NOT sent to the oracle but directly to admin ?
            trust_token_contract_0: "f597770adc303efe702fcc1497b87703d166adc9d2a5a4cd8e92c571b2324201_o1",  // official
            // beware if you activate one of those contracts without activating also legacy_ swapbot txs
            // the coins that have been sent trough a dephebot contracts will not load anymore
            // trust_test_token_contract_4: 	"a7e7bacc955e34b44e18a907d3f4386a488371255c58ea023b180a8d4419e732_o1", // tests swapbot with clients
            // trust_test_token_contract_5: 	"db31f13819e05a189796e34e607157e67ac318fe8396856870c6ec5124f0c295_o1", // test tokens with clients, 31.12.2021
            trust_test_token_contract_6: "9fce92fe58ae1aff06812dc1b8b13b11d147b5cfc74ce932b6d94b4246c66d49_o1",  // test tokens with clients, 22.04.2022
            // --------------------------------            
        }
    }
}
RunCraft.version = "0.0.2"
export default RunCraft


/* comment ref: #FDF4E5G43 // keep this!

Because we use trust: "cache" or trust: "state" and not trust: "*", it means
RUN will not load untrusted coins

And if these coins have interacted with a contract like a TokenBuyContract or TokenSellContract,
you NEED to keep those contracts in the trustlist, otherwise run will not be able to backtrack them
and will stop loading them, and the wallet will show 0 coins or less than it should.

to solve this: either use trust: "*" (security risk) or add all previously used contracts to the trustlist
*/
function get_legacy_trustlist() {
    return {
        // this is only mostly used to generate runcraft's cache
        /* !! ONCE SOME TOKENS INTERACT WITH A DELPHEBOT CONTRACT OR ANY CONTRACT, THEY WILL NOT LOAD ANYMORE UNLESS
            YOU ADD ALL THE CONTRACTS IT INTERACTED WITH TO THESE LEGACY CONTRACTS TO TRUST !!
            
            note: add the prefix legacy_#<incrementedNumber>_ to all so we don't have to deal with same-named entries
        */

        // did some shit and melt some contracts by sending bsv
        legacy_24_OracleRequest_USDpriced: "5f98e7d1ec9de05ddd0e94c881bc0dbbd4cb136f8af9b02bdabd3d4e603992e4_o1",

        legacy_23_Oracle_BSVUSD: "f64c00ea18548add324a08442ab7542c13f7a25ec892a19db90725e4f1d9887d_o1",
        legacy_22_Oracle_BSVEUR: "4f129594f5779cd8da339f7f4eca1714137b377d43807e1adc003964282028a0_o1",
        legacy_21_Oracle_Timestamp: "dc1466e874e76e4556d0ef5ed4704aa22eca53eda979e6b56092ded392d14e40_o1",
        legacy_20_Oracle_RandomValue: "28557608c08d56845ad05faa8ef0ef002bdb91dfd1c006e2a9a7b0d8e7e53f70_o1",

        // other stuff
        legacy_19_RunMath: "cc5f069ff8cb6d51f867536ccd798531223f6ebb63bbef5cb02d0bf41d78212b_o3",
        legacy_18_Use_OracleRequest_USDpriced: "cc5f069ff8cb6d51f867536ccd798531223f6ebb63bbef5cb02d0bf41d78212b_o1",
        legacy_17_BSV_Payment: "cc5f069ff8cb6d51f867536ccd798531223f6ebb63bbef5cb02d0bf41d78212b_o7",

        legacy_16_TokenSellRequest_Admin: "cc5f069ff8cb6d51f867536ccd798531223f6ebb63bbef5cb02d0bf41d78212b_o6",
        legacy_15_TokenSellRequest_User: "cc5f069ff8cb6d51f867536ccd798531223f6ebb63bbef5cb02d0bf41d78212b_o4",

        legacy_14_RunConvert: "1f23d53a0e99fc7756af3fcf74404955e604c5cbc608a75774b2ac6bf2c83436_o5",
        legacy_13_BSV_Refund: "8945204d239fece72abf00600b7812823b7099ff33d68b713304ba18b0930646_o6",

        legacy_12_TokenBuyRequest_User: "1f23d53a0e99fc7756af3fcf74404955e604c5cbc608a75774b2ac6bf2c83436_o3",
        legacy_11_TokenBuyRequest_Admin: "1f23d53a0e99fc7756af3fcf74404955e604c5cbc608a75774b2ac6bf2c83436_o7",
        legacy_10_AvailableTokensContract: "1f23d53a0e99fc7756af3fcf74404955e604c5cbc608a75774b2ac6bf2c83436_o8",
        legacy_9_Oracle_TokenBuyRequest_BasePrice: "1f23d53a0e99fc7756af3fcf74404955e604c5cbc608a75774b2ac6bf2c83436_o4",
        legacy_8_NotEnoughTokensLeftAtBasePrice: "1f23d53a0e99fc7756af3fcf74404955e604c5cbc608a75774b2ac6bf2c83436_o9",


        // before adding extract_satoshis()
        legacy_7_RunConvert: "8945204d239fece72abf00600b7812823b7099ff33d68b713304ba18b0930646_o7",
        legacy_6_TokenBuyRequest_User: "8945204d239fece72abf00600b7812823b7099ff33d68b713304ba18b0930646_o4",
        legacy_5_TokenBuyRequest_Admin: "8945204d239fece72abf00600b7812823b7099ff33d68b713304ba18b0930646_o9",
        legacy_4_AvailableTokensContract: "8945204d239fece72abf00600b7812823b7099ff33d68b713304ba18b0930646_o10",
        legacy_3_Oracle_TokenBuyRequest_BasePrice: "8945204d239fece72abf00600b7812823b7099ff33d68b713304ba18b0930646_o5",
        legacy_2_NotEnoughTokensLeftAtBasePrice: "8945204d239fece72abf00600b7812823b7099ff33d68b713304ba18b0930646_o11",

        /* 
        // add support for token type check 23.04.2022
        
                RunMath                             : "8d6785ceb0ddc6b7a5ade2de1b64eb40dd859606a018101744bdcf1aa81ecfc0_o3",
                Use_OracleRequest_USDpriced         : "8d6785ceb0ddc6b7a5ade2de1b64eb40dd859606a018101744bdcf1aa81ecfc0_o1",
                BSV_Payment                         : "8d6785ceb0ddc6b7a5ade2de1b64eb40dd859606a018101744bdcf1aa81ecfc0_o7",
                TokenSellRequest_Admin              : "8d6785ceb0ddc6b7a5ade2de1b64eb40dd859606a018101744bdcf1aa81ecfc0_o6",
                TokenSellRequest_User               : "8d6785ceb0ddc6b7a5ade2de1b64eb40dd859606a018101744bdcf1aa81ecfc0_o4",
    
                RunConvert                          : "a77d907e19f527918c6bf0618538c6901730a35289be1a5b17425cda550e021c_o7",
                TokenBuyRequest_User                : "a77d907e19f527918c6bf0618538c6901730a35289be1a5b17425cda550e021c_o4",
                TokenBuyRequest_Admin               : "a77d907e19f527918c6bf0618538c6901730a35289be1a5b17425cda550e021c_o9",
                AvailableTokensContract             : "a77d907e19f527918c6bf0618538c6901730a35289be1a5b17425cda550e021c_o10",
                Oracle_TokenBuyRequest_BasePrice    : "a77d907e19f527918c6bf0618538c6901730a35289be1a5b17425cda550e021c_o5",
                BSV_Refund                          : "a77d907e19f527918c6bf0618538c6901730a35289be1a5b17425cda550e021c_o6",
                NotEnoughTokensLeftAtBasePrice      : "a77d907e19f527918c6bf0618538c6901730a35289be1a5b17425cda550e021c_o11",
    
    
        // bug fix 15.04.2022
    
                RunMath                             : "d30254d98b2f053a96a2f58ceac6d6ee7356b57f44f22e863ad28dc4a453a30b_o3",
                Use_OracleRequest_USDpriced         : "d30254d98b2f053a96a2f58ceac6d6ee7356b57f44f22e863ad28dc4a453a30b_o1",
                BSV_Payment                         : "d30254d98b2f053a96a2f58ceac6d6ee7356b57f44f22e863ad28dc4a453a30b_o6",
                TokenSellRequest_Admin              : "d30254d98b2f053a96a2f58ceac6d6ee7356b57f44f22e863ad28dc4a453a30b_o5",
                TokenSellRequest_User               : "d30254d98b2f053a96a2f58ceac6d6ee7356b57f44f22e863ad28dc4a453a30b_o4",
    
        // 13.04.2022
    
                OracleRequest_USDpriced   : "58585486eb6c62fab8fefb25100857971a1c6187223c3174d3e0bb0bb52ae566_o1",
    
                Oracle_BSVUSD             : "4ac94fb3a885c87a1c27ff1f7fe6cac9ceb918ad3a0073badca5ae3066ad2c07_o1",
                Oracle_BSVEUR             : "c86aa57ed1f916f0f883fe8ec12db5682bd49e6154fb088689ad9b5817113036_o1",
                Oracle_Timestamp          : "4dab33c6dfc24bed789eea6416c46dc2be11559f4682701dfd077e2ee1a29ef9_o1",
                Oracle_RandomValue        : "541a2a75ed61064ab659ed3b3200872abd2e426171c062fe1ddeb65d81033293_o1",
    
                // // //  token buy
                
                // BEWARE DO NOT REDEPLOY BEFORE TURNING OFF CACHE OR YOU WILL GET METADATA MISMATCH
                // BEWARE COMMENTING OR DELETING CONTRACTS HERE CAN MAKE SOME COINS DISAPPEAR, to read more search: #FDF4E5G43
                
                RunMath                             : "a748f6183ca9cdb1d4840e13e6cf178e5ae7a236fa585991fd538bfa6d42b01e_o3",
                Use_OracleRequest_USDpriced         : "a748f6183ca9cdb1d4840e13e6cf178e5ae7a236fa585991fd538bfa6d42b01e_o1",
                BSV_Payment                         : "a748f6183ca9cdb1d4840e13e6cf178e5ae7a236fa585991fd538bfa6d42b01e_o6",
                TokenSellRequest_Admin              : "a748f6183ca9cdb1d4840e13e6cf178e5ae7a236fa585991fd538bfa6d42b01e_o5",
                TokenSellRequest_User               : "a748f6183ca9cdb1d4840e13e6cf178e5ae7a236fa585991fd538bfa6d42b01e_o4",
                
                // // // token sell
    
                // BEWARE DO NOT REDEPLOY BEFORE TURNING OFF CACHE OR YOU WILL GET METADATA MISMATCH
                // BEWARE COMMENTING OR DELETING CONTRACTS HERE CAN MAKE SOME COINS DISAPPEAR, to read more search: #FDF4E5G43
                            
                RunConvert                          : "2103b5e96e7efbe078a0c148259455c80db3a0e6e27f34548486324e7626d76b_o7",
                TokenBuyRequest_User                : "2103b5e96e7efbe078a0c148259455c80db3a0e6e27f34548486324e7626d76b_o4",
                TokenBuyRequest_Admin               : "2103b5e96e7efbe078a0c148259455c80db3a0e6e27f34548486324e7626d76b_o9",
                AvailableTokensContract             : "2103b5e96e7efbe078a0c148259455c80db3a0e6e27f34548486324e7626d76b_o10",
                Oracle_TokenBuyRequest_BasePrice    : "2103b5e96e7efbe078a0c148259455c80db3a0e6e27f34548486324e7626d76b_o5",
                BSV_Refund                          : "2103b5e96e7efbe078a0c148259455c80db3a0e6e27f34548486324e7626d76b_o6",
                NotEnoughTokensLeftAtBasePrice      : "2103b5e96e7efbe078a0c148259455c80db3a0e6e27f34548486324e7626d76b_o11",      
        */

        // as of 07.04.2022 we are moving to real delphes so we reset all legacy_ stuff
        /*
        legacy_1_RunMath                            : "7528b67cf5086a278a2d900e0934c88ae9d2aba71999bd9ece425f60ed6fadbf_o3",
        legacy_2_Use_OracleRequest_USDpriced        : "7528b67cf5086a278a2d900e0934c88ae9d2aba71999bd9ece425f60ed6fadbf_o1",
        legacy_3_BSV_Payment                        : "7528b67cf5086a278a2d900e0934c88ae9d2aba71999bd9ece425f60ed6fadbf_o6",
        legacy_4_TokenSellRequest_Admin             : "7528b67cf5086a278a2d900e0934c88ae9d2aba71999bd9ece425f60ed6fadbf_o5",
        legacy_5_TokenSellRequest_User              : "7528b67cf5086a278a2d900e0934c88ae9d2aba71999bd9ece425f60ed6fadbf_o4",
        legacy_6_RunMath                            : "5b6f858157b4a5f5087749a491c550ec6500ec2d8335243986024d59510bfd5b_o3",
        legacy_7_Use_OracleRequest_USDpriced        : "5b6f858157b4a5f5087749a491c550ec6500ec2d8335243986024d59510bfd5b_o1",
        legacy_8_BSV_Payment                        : "5b6f858157b4a5f5087749a491c550ec6500ec2d8335243986024d59510bfd5b_o6",
        legacy_9_TokenSellRequest_Admin             : "5b6f858157b4a5f5087749a491c550ec6500ec2d8335243986024d59510bfd5b_o5",
        legacy_10_TokenSellRequest_User             : "5b6f858157b4a5f5087749a491c550ec6500ec2d8335243986024d59510bfd5b_o4",
        legacy_11_Oracle_RandomValue                : "0a6cf849bf7d6586f3a230f4e95e623992ff9bfba1c322422833f3f596d90cc1_o2",
        legacy_12_Oracle_BSVUSD                     : "c2a7640a439b9e0e6e5ffef6466fba461eb567d6292e416fd3a691a06753a6eb_o2",
        legacy_13_Oracle_Timestamp                  : "a6e927b311cd9a892faffdf93dfe6b72f805dd90917980955235edff54119011_o2",
        legacy_14_Oracle_BSVEUR                     : "9801a5e6962b0585fc45eb426681db3f00187e82c02d04fbbbe4f79bf5a42a90_o2",
        legacy_15_OracleRequest_USDpriced           : "c14c61ff2b58999d03729c26f6382bcaa48d8260c8dd0a9d04741790b5793c28_o1",
        legacy_16_OracleRequest_USDpriced           : "11ff330b1f3554670ef2ec317d1c8f201423f4ae2ecff40d264b8688c0c27132_o1", 
        legacy_17_TokenBuyRequest_User              : "70072d551b2f86e17e48eb36fa43caaa5ee2503e28f00bebbc88962469d1091b_o4",
        legacy_18_TokenBuyRequest_Admin             : "70072d551b2f86e17e48eb36fa43caaa5ee2503e28f00bebbc88962469d1091b_o7",
        legacy_19_AvailableTokensContract           : "70072d551b2f86e17e48eb36fa43caaa5ee2503e28f00bebbc88962469d1091b_o8",
        legacy_20_Oracle_TokenBuyRequest_BasePrice  : "70072d551b2f86e17e48eb36fa43caaa5ee2503e28f00bebbc88962469d1091b_o5",
        legacy_21_BSV_Refund                        : "70072d551b2f86e17e48eb36fa43caaa5ee2503e28f00bebbc88962469d1091b_o6",
        legacy_22_NotEnoughTokensLeftAtBasePrice    : "70072d551b2f86e17e48eb36fa43caaa5ee2503e28f00bebbc88962469d1091b_o9",
    
        // since those are just token contracts, they should not be required to trust ?
        // trust_test_token_contract_1: "73e3ddb3e7cadd783971bb15cb22b2ccbf30fcd22fc892ee009f9dedfd04a0a2_o1", // personal dev
        // trust_test_token_contract_2: "c64d18e1cb501980f7a30aa3b6aee24d6725297c22e2f11a4346cf509e5c61ea_o1", // personal dev
        // trust_test_token_contract_3: "2c510fdf81c74c0c3e8ccb44e893e4dfc44fefa10b92bc154d0f2dcff47c82e5_o1" // tests personal  
        
        // _____________________________
        //
        // for swapbot tests on token contract db31f13819e05a189796e34e607157e67ac318fe8396856870c6ec5124f0c295_o1
        //
        legacy_23_OracleRequest_USDpriced		: "451e632c33664de0df358f4083120e10e560d4144568844bc04368c19e81bb0b_o1",
        legacy_24_Oracle_RandomValue          	: "d43c4dd3d84599decd45138a023d83153a1cf992e3ecc29678ab6582c3eb65e9_o2",
        legacy_25_Oracle_BSVUSD					: "30eb83566142c2bfabe450bb1a249ff258c73406faa127d4de0457153e992769_o2",
        legacy_26_Oracle_Timestamp            	: "89052d579b249a62241c45d93e14d04cdaa7b00fc8fc6bbcf2249f3eb38230be_o2",
        legacy_27_Oracle_BSVEUR					: "d49eb47293be7aa291fbaa8992707aa9b0c0524812c4e8b3c4330a2190b0e257_o2",
    
        legacy_28_RunMath							: "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o3",
        legacy_29_Use_OracleRequest_USDpriced		: "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o1",
        legacy_30_BSV_Payment						: "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o6",
        legacy_31_TokenSellRequest_Admin			: "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o5",
        legacy_32_TokenSellRequest_User				: "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o4",
    
        legacy_33_TokenBuyRequest_User				: "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o4",
        legacy_34_TokenBuyRequest_Admin				: "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o7",
        legacy_35_AvailableTokensContract			: "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o8",
        legacy_36_Oracle_TokenBuyRequest_BasePrice	: "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o5",
        legacy_37_BSV_Refund						: "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o6",
        legacy_38_NotEnoughTokensLeftAtBasePrice	: "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o9",
    
        legacy_39_Oracle_BSVUSD						: "3e4d76c7641fe35f91fbce2cbb36cc5049ced80bebf9d8ec56ae04144fbaa94c_o2",
        legacy_40_Oracle_BSVEUR						: "fed80738e2f120232a08ed5995dab239cf433fd8a9fe0decf31000b68ec7ccf8_o2",
        legacy_41_Oracle_Timestamp					: "b8cc042c40155fc4b7045fba9148462d99b5297b324aab8b7b08c8828d824af4_o2",
        legacy_42_Oracle_RandomValue				: "d21faaa12741cd12d3ae37bd5f2c7aa49b7edfa9a7721e22b032a84c2ba7fd21_o2",
    
        legacy_43_RunMath							: "52e05c24b03c123fe01743f348ffbc77d04eaa1a70fa3b753e7053adda46d3e0_o3",
        legacy_44_Use_OracleRequest_USDpriced         : "52e05c24b03c123fe01743f348ffbc77d04eaa1a70fa3b753e7053adda46d3e0_o1",
        legacy_45_BSV_Payment                         : "52e05c24b03c123fe01743f348ffbc77d04eaa1a70fa3b753e7053adda46d3e0_o6",
        legacy_46_TokenSellRequest_Admin              : "52e05c24b03c123fe01743f348ffbc77d04eaa1a70fa3b753e7053adda46d3e0_o5",
        legacy_47_TokenSellRequest_User               : "52e05c24b03c123fe01743f348ffbc77d04eaa1a70fa3b753e7053adda46d3e0_o4",
        legacy_48_RunMath                             : "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o3",
        legacy_49_Use_OracleRequest_USDpriced         : "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o1",
        legacy_50_BSV_Payment                         : "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o6",
        legacy_51_TokenSellRequest_Admin              : "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o5",
        legacy_52_TokenSellRequest_User               : "71eab00d1c0b2253c1162f0a6f9e782b7a4467a80a755e4604225cf26b6344d3_o4",
    
        legacy_53_TokenBuyRequest_User                : "4ca923df3adcf5e4c0cef9226a9050c95fc92f594352318326b9a6ecf4bb2080_o4",
        legacy_54_TokenBuyRequest_Admin               : "4ca923df3adcf5e4c0cef9226a9050c95fc92f594352318326b9a6ecf4bb2080_o7",
        legacy_55_AvailableTokensContract             : "4ca923df3adcf5e4c0cef9226a9050c95fc92f594352318326b9a6ecf4bb2080_o8",
        legacy_56_Oracle_TokenBuyRequest_BasePrice    : "4ca923df3adcf5e4c0cef9226a9050c95fc92f594352318326b9a6ecf4bb2080_o5",
        legacy_57_BSV_Refund                          : "4ca923df3adcf5e4c0cef9226a9050c95fc92f594352318326b9a6ecf4bb2080_o6",
        legacy_58_NotEnoughTokensLeftAtBasePrice      : "4ca923df3adcf5e4c0cef9226a9050c95fc92f594352318326b9a6ecf4bb2080_o9",
        legacy_59_TokenBuyRequest_User                : "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o4",
        legacy_60_TokenBuyRequest_Admin               : "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o7",
        legacy_61_AvailableTokensContract             : "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o8",
        legacy_62_Oracle_TokenBuyRequest_BasePrice    : "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o5",
        legacy_63_BSV_Refund                          : "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o6",
        legacy_64_NotEnoughTokensLeftAtBasePrice      : "4ab686924f02437814b5533500c9096bacb72f996417081e4d62d8778451b6f1_o9",
    
        legacy_65_TokenBuyRequest_User                : "d70955aa0889b2d346771766222e00f157cb7f249737217b9e104c89d0a5c319_o4",
        legacy_66_TokenBuyRequest_Admin               : "d70955aa0889b2d346771766222e00f157cb7f249737217b9e104c89d0a5c319_o7",
        legacy_67_AvailableTokensContract             : "d70955aa0889b2d346771766222e00f157cb7f249737217b9e104c89d0a5c319_o8",
        legacy_68_Oracle_TokenBuyRequest_BasePrice    : "d70955aa0889b2d346771766222e00f157cb7f249737217b9e104c89d0a5c319_o5",
        legacy_69_BSV_Refund                          : "d70955aa0889b2d346771766222e00f157cb7f249737217b9e104c89d0a5c319_o6",
        legacy_70_NotEnoughTokensLeftAtBasePrice      : "d70955aa0889b2d346771766222e00f157cb7f249737217b9e104c89d0a5c319_o9",
        
        legacy_71_TokenBuyRequest_Admin               : "75f63e36ab57da4e90b61a04f26eda3638ea44eba2d9c14b909520bf6b5b18bd_o7",
        legacy_72_Oracle_TokenBuyRequest_BasePrice    : "75f63e36ab57da4e90b61a04f26eda3638ea44eba2d9c14b909520bf6b5b18bd_o5",
        legacy_73_TokenBuyRequest_User                : "75f63e36ab57da4e90b61a04f26eda3638ea44eba2d9c14b909520bf6b5b18bd_o4",
        legacy_74_AvailableTokensContract             : "75f63e36ab57da4e90b61a04f26eda3638ea44eba2d9c14b909520bf6b5b18bd_o8",
        legacy_75_BSV_Refund                          : "75f63e36ab57da4e90b61a04f26eda3638ea44eba2d9c14b909520bf6b5b18bd_o6",
        legacy_76_NotEnoughTokensLeftAtBasePrice      : "75f63e36ab57da4e90b61a04f26eda3638ea44eba2d9c14b909520bf6b5b18bd_o9",
         
        // forgot those one that seem necessary also
        legacy_71_ : "e9f1c14223c466116ac65e68770cc2f84c158c7592ef4471a5d38d08a02604cf_o8",
        legacy_73_ : "e9f1c14223c466116ac65e68770cc2f84c158c7592ef4471a5d38d08a02604cf_o4",
        legacy_74_ : "e9f1c14223c466116ac65e68770cc2f84c158c7592ef4471a5d38d08a02604cf_o1",
        legacy_75_ : "e9f1c14223c466116ac65e68770cc2f84c158c7592ef4471a5d38d08a02604cf_o5",
        legacy_76_ : "e9f1c14223c466116ac65e68770cc2f84c158c7592ef4471a5d38d08a02604cf_o7",
        legacy_77_ : "b78fd8fd041e8677e729c8d2b36d0353993764a8d9ec36efb9b368be0f1f41d3_o1",
        legacy_78_ : "b78fd8fd041e8677e729c8d2b36d0353993764a8d9ec36efb9b368be0f1f41d3_o3",
        legacy_79_ : "633ba4dcd1324614bafcb3a397ccc3edf819acbdd94f24b67cb48c41e7c7b08e_o2",
        legacy_80_ : "b23e757b7ad15bdf752c53a57dee3376f71f392adb68d759d7d4e70cc01b98c0_o1",
        legacy_81_ : "b23e757b7ad15bdf752c53a57dee3376f71f392adb68d759d7d4e70cc01b98c0_o2",
        legacy_82_ : "c8e2d3a97eada9b00506c48f20d1853ac5a44feee095f1cd4c5081f496570ade_o2",
        //
        // _____________________________
        //
        legacy_83_OracleRequest_USDpriced     	    : "ce0292a56fd62c58b3815d9195abe191eff8ba5d5bf744c41b22f0804edb3b4d_o1",
        legacy_84_Oracle_BSVUSD               	    : "327e0f47c0be95dbd596b8d57626ccfde0bd9131cf3d4f596e0b7185afdd9a48_o2",
        legacy_85_Oracle_BSVEUR                     : "bb1e6d0da562bd0967523826540b64589fa06504e902ba3802bd7d9f7f287bac_o2",
        legacy_86_Oracle_Timestamp            	    : "b3d349bf7df27538d0a38f969529b2a5c39bd8209733047d1706a1a94f53fae6_o2",
        legacy_87_Oracle_RandomValue          	    : "de4bdbe84c68f60a1642a0b5b2741f8dd0c70896ca03a6d1daf3f8269af10f15_o2",
        legacy_88_RunMath                           : "8b53b8f836bfc6f5f30ee104d243b58dd25cb40e07abe33303c476f59223f10c_o3",
        legacy_89_Use_OracleRequest_USDpriced       : "8b53b8f836bfc6f5f30ee104d243b58dd25cb40e07abe33303c476f59223f10c_o1",
        legacy_90_BSV_Payment                       : "8b53b8f836bfc6f5f30ee104d243b58dd25cb40e07abe33303c476f59223f10c_o6",
        legacy_91_TokenSellRequest_Admin            : "8b53b8f836bfc6f5f30ee104d243b58dd25cb40e07abe33303c476f59223f10c_o5",
        legacy_92_TokenSellRequest_User             : "8b53b8f836bfc6f5f30ee104d243b58dd25cb40e07abe33303c476f59223f10c_o4",
        legacy_93_TokenBuyRequest_User              : "b0d8ab51a57e0444392dde348f04c03278e6f0c3d693c58c6969f3bf7c350db8_o4",
        legacy_94_TokenBuyRequest_Admin             : "b0d8ab51a57e0444392dde348f04c03278e6f0c3d693c58c6969f3bf7c350db8_o7",
        legacy_95_AvailableTokensContract           : "b0d8ab51a57e0444392dde348f04c03278e6f0c3d693c58c6969f3bf7c350db8_o8",
        legacy_96_Oracle_TokenBuyRequest_BasePrice  : "b0d8ab51a57e0444392dde348f04c03278e6f0c3d693c58c6969f3bf7c350db8_o5",
        legacy_97_BSV_Refund                        : "b0d8ab51a57e0444392dde348f04c03278e6f0c3d693c58c6969f3bf7c350db8_o6",
        legacy_98_NotEnoughTokensLeftAtBasePrice    : "b0d8ab51a57e0444392dde348f04c03278e6f0c3d693c58c6969f3bf7c350db8_o9",
    
        legacy_99_OracleRequest_USDpriced           : "fcf4b1c621c40e77f7266b3c74a6726cb8301ec3a3f683b306dde48a36916319_o1",
        legacy_100_Oracle_BSVUSD                    : "4ee5281987779d30241a9533746c3c328d0b3fb63413593358c295134aef1990_o2",
        legacy_101_Oracle_BSVEUR                    : "144f5dc5196c1b0ba2d4086e919133dbd050a89b8301347317354364858b2b7f_o2",
        legacy_102_Oracle_Timestamp            	    : "6f6f69b836e94cff63ce6e12c2c8da9662d7f34381b924253d99e3e013ab1707_o2",
        legacy_103_Oracle_RandomValue               : "4b920fe797fd9aa824d7d186ef908b6e694787e653c0602fa2d76c4a94413aee_o2",
        legacy_104_RunMath                          : "b473905823b0d83ad2a7e429af502ee368c5dc6e7de87504db4838c13388a2db_o3",
        legacy_105_Use_OracleRequest_USDpriced      : "b473905823b0d83ad2a7e429af502ee368c5dc6e7de87504db4838c13388a2db_o1",
        legacy_106_BSV_Payment                      : "b473905823b0d83ad2a7e429af502ee368c5dc6e7de87504db4838c13388a2db_o6",
        legacy_107_TokenSellRequest_Admin           : "b473905823b0d83ad2a7e429af502ee368c5dc6e7de87504db4838c13388a2db_o5",
        legacy_108_TokenSellRequest_User            : "b473905823b0d83ad2a7e429af502ee368c5dc6e7de87504db4838c13388a2db_o4",
        legacy_109_RunConvert                       : "66bba89568e43a16ffa2078846f494a59c047b23ed3d402225a4253ee14941ec_o7",
        legacy_110_TokenBuyRequest_User             : "66bba89568e43a16ffa2078846f494a59c047b23ed3d402225a4253ee14941ec_o4",
        legacy_111_TokenBuyRequest_Admin            : "66bba89568e43a16ffa2078846f494a59c047b23ed3d402225a4253ee14941ec_o9",
        legacy_112_AvailableTokensContract          : "66bba89568e43a16ffa2078846f494a59c047b23ed3d402225a4253ee14941ec_o10",
        legacy_113_Oracle_TokenBuyRequest_BasePrice : "66bba89568e43a16ffa2078846f494a59c047b23ed3d402225a4253ee14941ec_o5",
        legacy_114_BSV_Refund                       : "66bba89568e43a16ffa2078846f494a59c047b23ed3d402225a4253ee14941ec_o6",
        legacy_115_NotEnoughTokensLeftAtBasePrice   : "66bba89568e43a16ffa2078846f494a59c047b23ed3d402225a4253ee14941ec_o11",
    
        legacy_116_OracleRequest_USDpriced          : "9ac950c8c398fb8265749aa160bfdd575030774c4f27f2bc21611eb1dbfea8c5_o1",
        legacy_117_Oracle_BSVUSD                    : "7c93ce424a0dcecd800c6df2e90f06f8abfccf3b995a3fd8c664839fda7e3c23_o1",
        legacy_118_Oracle_BSVEUR                    : "ccd28bc063083e37c833e391025b072c4b62c3ba9f041b9a0398d88660e1f680_o1",
        legacy_119_Oracle_Timestamp                 : "d6692867d1a2e161c41c9a1023f6278be9e7f254bcb3f76f7a7e3cffcf3b3722_o1",
        legacy_120_Oracle_RandomValue               : "ab9f19d821e499aaf7623d9c0c36bcc55160a2fc468603ab953f40d48d3a6e4c_o1",
        legacy_121_RunMath                          : "debe187a5ed17090ab4130d5e65941796f093a7ae9ac98e487f55b7d35794ad0_o3",
        legacy_122_Use_OracleRequest_USDpriced      : "debe187a5ed17090ab4130d5e65941796f093a7ae9ac98e487f55b7d35794ad0_o1",
        legacy_123_BSV_Payment                      : "debe187a5ed17090ab4130d5e65941796f093a7ae9ac98e487f55b7d35794ad0_o6",
        legacy_124_TokenSellRequest_Admin           : "debe187a5ed17090ab4130d5e65941796f093a7ae9ac98e487f55b7d35794ad0_o5",
        legacy_125_TokenSellRequest_User            : "debe187a5ed17090ab4130d5e65941796f093a7ae9ac98e487f55b7d35794ad0_o4",
        legacy_126_RunConvert                       : "1eb9fff87c10088930bc3fced3131be1bb6d776df3ca9f32d254ae69feeeed79_o7",
        legacy_127_TokenBuyRequest_User             : "1eb9fff87c10088930bc3fced3131be1bb6d776df3ca9f32d254ae69feeeed79_o4",
        legacy_128_TokenBuyRequest_Admin            : "1eb9fff87c10088930bc3fced3131be1bb6d776df3ca9f32d254ae69feeeed79_o9",
        legacy_129_AvailableTokensContract          : "1eb9fff87c10088930bc3fced3131be1bb6d776df3ca9f32d254ae69feeeed79_o10",
        legacy_130_Oracle_TokenBuyRequest_BasePrice : "1eb9fff87c10088930bc3fced3131be1bb6d776df3ca9f32d254ae69feeeed79_o5",
        legacy_131_BSV_Refund                       : "1eb9fff87c10088930bc3fced3131be1bb6d776df3ca9f32d254ae69feeeed79_o6",
        legacy_132_NotEnoughTokensLeftAtBasePrice   : "1eb9fff87c10088930bc3fced3131be1bb6d776df3ca9f32d254ae69feeeed79_o11",
        
        legacy_133_RunConvert                          : "faeca2dbf8dce86c634025c0e0f1bcdd3faca435e44d9476b09ba69d72c78527_o7",
        legacy_134_TokenBuyRequest_User                : "faeca2dbf8dce86c634025c0e0f1bcdd3faca435e44d9476b09ba69d72c78527_o4",
        legacy_135_TokenBuyRequest_Admin               : "faeca2dbf8dce86c634025c0e0f1bcdd3faca435e44d9476b09ba69d72c78527_o9",
        legacy_136_AvailableTokensContract             : "faeca2dbf8dce86c634025c0e0f1bcdd3faca435e44d9476b09ba69d72c78527_o10",
        legacy_137_Oracle_TokenBuyRequest_BasePrice    : "faeca2dbf8dce86c634025c0e0f1bcdd3faca435e44d9476b09ba69d72c78527_o5",
        legacy_138_BSV_Refund                          : "faeca2dbf8dce86c634025c0e0f1bcdd3faca435e44d9476b09ba69d72c78527_o6",
        legacy_139_NotEnoughTokensLeftAtBasePrice      : "faeca2dbf8dce86c634025c0e0f1bcdd3faca435e44d9476b09ba69d72c78527_o11",
        */
    }
}
